import { type DataSource } from '@coris-ts/repository/data-source/data-source'
import { UserEntity } from './entities/user.entity'

// This data source is kept for backwards compatibility but user data is now
// primarily obtained from Clerk via the App.tsx component which syncs Clerk
// user data to the internal UserProvider context.

export class MockUserDataSource implements DataSource<UserEntity> {
  async get(): Promise<UserEntity> {
    // Try to get user data from Clerk if available
    const clerkUser = window.Clerk?.user

    if (clerkUser) {
      return new UserEntity(
        clerkUser.id,
        clerkUser.primaryEmailAddress?.emailAddress ?? '',
        clerkUser.primaryEmailAddress?.verification?.status === 'verified',
        clerkUser.fullName ?? clerkUser.firstName ?? '',
        clerkUser.imageUrl ?? '',
        (clerkUser.publicMetadata?.customerId as string) ?? clerkUser.id
      )
    }

    // Fallback for when Clerk is not yet initialized
    return new UserEntity('loading', '', false, '', '', '')
  }

  async getAll(): Promise<UserEntity[]> {
    return [await this.get()]
  }

  async put(value: UserEntity | undefined): Promise<UserEntity> {
    // User updates should be handled through Clerk's user management
    return value ?? (await this.get())
  }

  async putAll(values: UserEntity[] | undefined): Promise<UserEntity[]> {
    return values ?? [await this.get()]
  }

  async delete(): Promise<void> {
    // User deletion should be handled through Clerk's user management
  }
}
